// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal{
    position: absolute;
    display: flex;
    z-index: 99999999999999999999999;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh; 
    overflow: hidden;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.3);
}

.modal-content{
    width: 400px;
    height: 100%;
    background-color: white;
    margin-left: auto;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes slideOut {
    from {
        transform: translateX(0);
        opacity: 1;
    }
    to {
        transform: translateX(100%);
        opacity: 0;
    }
}

.modal-content {
    width: 440px;
    height: 100%;
    background-color: white;
    margin-left: auto;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    animation: slideIn 0.5s forwards;
}



.modal-content.hide {
    animation: slideOut 0.5s forwards;
}`, "",{"version":3,"sources":["webpack://./src/Components/style/modal.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,gCAAgC;IAChC,OAAO;IACP,MAAM;IACN,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,2BAA2B;QAC3B,UAAU;IACd;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,4BAA4B;IAC5B,+BAA+B;IAC/B,gCAAgC;AACpC;;;;AAIA;IACI,iCAAiC;AACrC","sourcesContent":[".modal{\n    position: absolute;\n    display: flex;\n    z-index: 99999999999999999999999;\n    left: 0;\n    top: 0;\n    width: 100vw;\n    height: 100vh; \n    overflow: hidden;\n    background-color: rgb(0,0,0);\n    background-color: rgba(0,0,0,0.3);\n}\n\n.modal-content{\n    width: 400px;\n    height: 100%;\n    background-color: white;\n    margin-left: auto;\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n}\n\n@keyframes slideIn {\n    from {\n        transform: translateX(100%);\n        opacity: 0;\n    }\n    to {\n        transform: translateX(0);\n        opacity: 1;\n    }\n}\n\n@keyframes slideOut {\n    from {\n        transform: translateX(0);\n        opacity: 1;\n    }\n    to {\n        transform: translateX(100%);\n        opacity: 0;\n    }\n}\n\n.modal-content {\n    width: 440px;\n    height: 100%;\n    background-color: white;\n    margin-left: auto;\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n    animation: slideIn 0.5s forwards;\n}\n\n\n\n.modal-content.hide {\n    animation: slideOut 0.5s forwards;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
